module.exports = __webpack_public_path__ + "static/media/USLUGA3.aeb51727.jpg";